import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const portTypeApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.string(),
  id: v.number(),
  lookupCodeType: v.string(),
});

export const portTypeSchema = v.object({
  ...optionSchema.entries,
  id: v.string(),
});

export const portTypesApiSchema = paginatedSchema(portTypeApiSchema);

export type PortTypeApi = v.InferOutput<typeof portTypeApiSchema>;
export type PortTypesApi = v.InferOutput<typeof portTypesApiSchema>;

export type PortTypeFilters = Filters<PortTypeApi>;

export type PortTypeFiltersUpdateApi = FiltersUpdateApi<PortTypeApi>;

export type PortType = Prettify<Option<v.InferOutput<typeof portTypeSchema>>>;

export type PortTypes = Entities<PortType>;
